<template>
  <div v-if="experts.length > 0" class="experts">
    <div
      class="expert-card-wrapper"
      v-for="item in experts"
      :key="item.id"
      @click="
        $router.push({
          path: '/index/experts/detail',
          query: {
            id: item.id,
          },
        })
      "
    >
      <div class="expert-card">
        <img class="avatar" :src="item.avatar" />
        <div class="expert-info">
          <div class="name">{{ item.name }}</div>
          <div class="hospital">{{ item.hospital_name || "未知医院" }}</div>

          <div class="title">
            {{ item.departs_name || "未知" }}
            {{ item.job_title_name || "未知" }}
          </div>
          <div class="introduce">
            {{ item.brief || "此专家暂无简介哦" }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <el-empty description="暂时没有专家哦~"></el-empty>
  </div>
</template>
<script lang="ts">
interface Expert {
  job: string;
  name: string;
  hospital_name: string;
  job_title: string;
  introduction: string;
}
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "expert-card",
  props: {
    experts: {
      type: Array as PropType<Expert>,
      default: () => {
        return [];
      },
    },
  },
});
</script>

<style lang="less" scoped>
.experts {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-top: 50px;

  .expert-card-wrapper {
    width: 25%;
  }

  .expert-card {
    flex-shrink: 0;
    width: 360px;
    height: 296px;
    background: #ffffff;
    box-shadow: 2px 1px 30px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    position: relative;
    cursor: pointer;

    &:hover {
      box-shadow: 2px 1px 30px 0px rgba(0, 0, 0, 0.28);
      .avatar {
        box-shadow: 2px 1px 30px 0px rgba(0, 0, 0, 0.28);
      }
    }

    .avatar {
      position: absolute;
      height: 104px;
      width: 104px;
      border-radius: 10px;
      left: 128px;
      top: -30px;
      object-fit: cover;
    }

    .expert-info {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 94px;
      .name {
        font-size: 24px;
        font-weight: 400;
        color: #111111;
      }

      .hospital {
        max-width: 80%;
        font-size: 16px;
        font-weight: 400;
        color: #888888;
        margin-top: 20px;
        height: 23px;
        line-height: 23px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .title {
        max-width: 80%;
        font-size: 16px;
        font-weight: 400;
        color: #888888;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .introduce {
        text-align: center;
        width: 254px;
        height: 48px;
        line-height: 24px;
        font-size: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-weight: 400;
        color: #888888;
        overflow: hidden;
        margin-top: 30px;
      }
    }
  }
}
</style>
